import React from 'react'

export default function Spinner(props) {
    return (
        <div className="spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}

export function WhiteSpinner(props) {
    return (
        <div className="spinner white-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    )
}